import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/autoplay";
import "./sponsors.css";

import Logo1 from "../../../Assets/Images/home/gallery1-1(1).png";
import Logo2 from "../../../Assets/Images/home/gallery2-1(1).png";
import Logo3 from "../../../Assets/Images/home/gallery3-1.png";
import Logo4 from "../../../Assets/Images/home/gallery4-1.png";
import Logo5 from "../../../Assets/Images/home/gallery5-1(1).png";
import Logo6 from "../../../Assets/Images/home/gallery6-1.png";

const Sponsors = ({ brValue = 1.28 }) => {
  const logos = [Logo1, Logo2, Logo3, Logo4, Logo5, Logo6];

  return (
    <div
      style={{ "--br-value": `${brValue}` }}
      className="sponsor-section brightness"
    >
      <div className="container">
        <h2 className="sponsor-title text-clip">Our Sponsors</h2>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 1500, disableOnInteraction: false }}
          loop={true}
          spaceBetween={20}
          slidesPerView={5}
          breakpoints={{
            0: { slidesPerView: 2 },
            500: { slidesPerView: 3 },
            900: { slidesPerView: 4 },
            1300: { slidesPerView: 5 },
          }}
        >
          {logos.map((logo, index) => (
            <SwiperSlide key={index}>
              <div className={`sponsor-item sponsor-${index}`}>
                <img src={logo} alt="" />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Sponsors;
